module.exports = __webpack_public_path__ + "img/ic_fluent_arrow_download_20_regular.fb585670.svg";